import { render, staticRenderFns } from "./EditBtn.vue?vue&type=template&id=836931a6&scoped=true"
import script from "./EditBtn.vue?vue&type=script&lang=js"
export * from "./EditBtn.vue?vue&type=script&lang=js"
import style0 from "./EditBtn.vue?vue&type=style&index=0&id=836931a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836931a6",
  null
  
)

export default component.exports